import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const HeaderWrapper = styled.div(({ theme }) => ({
    padding: `${theme.spacing.xxSmall} 0`,
}));

export const TitleText = styled(Text)<{ isDisabled?: boolean }>(({ theme, isDisabled }) => ({
    color: isDisabled
        ? theme.colors[theme.colorMode].text_Low_Emphasis
        : theme.colors[theme.colorMode].text_Highest_Emphasis,
}));

export const SubTitleText = styled(Text)<{ isDisabled?: boolean }>(({ theme, isDisabled }) => ({
    color: isDisabled
        ? theme.colors[theme.colorMode].text_Low_Emphasis
        : theme.colors[theme.colorMode].text_Med_Emphasis,
}));
